import React, {useEffect, useState} from 'react';
import './style.scss';
import media from '../../media';


export default function Loader(props) {
    return (
        <div className="loader">
            <div className="circle"></div>
        </div>
    )
}
